
/// <amd-module name="Environments/CreatePanel/Components/EnvironmentDetailsViewComponent" />
import * as React from "react";

import { SingleLineTextMaxLength, MultiLineTextMaxLength } from "Environments/CreatePanel/Common/Utils";
import * as Resources from "Environments/CreatePanel/Resources";

import { FormItem } from "VSSUI/FormItem";
import { Icon } from "VSSUI/Icon";
import { TextField } from "VSSUI/TextField";
import { focusAsync, IFocusable } from "VSSUI/Utilities/Focus";

interface IEnvironmentDetailsProperties {
    onEnvironmentNameChange?: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, value: string) => void;
    onEnvironmentDescriptionChange?: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, value: string) => void;
    environmentName?: string | undefined;
    environmentDescription?: string | undefined;
    instanceId: string;
}

export class EnvironmentDetailsViewComponent extends React.Component<IEnvironmentDetailsProperties, {}> {

    public render(): JSX.Element {
        return (
            <div className="flex-column">
                <div key={Resources.EnvironmentName}>
                    <div>
                        <div className="flex-center flex-row margin-vertical-8">
                            {Resources.EnvironmentName}
                            {<Icon
                                className="more-info-icon env-panel-info"
                                iconName="Info"
                                tooltipProps={{ text: Resources.TypeEnvironmentName }}
                                tabIndex={0}
                                ariaLabel={Resources.TypeEnvironmentName}/>
                            }
                        </div>
                        <FormItem className="form-label-margin body-m">
                            <TextField
                                placeholder={Resources.TypeEnvironmentName}
                                maxLength={SingleLineTextMaxLength}
                                value={this.props.environmentName || "" }
                                onChange={this.props.onEnvironmentNameChange}
                                ref={this._environmentNameField}
                                required
                            />
                        </FormItem>
                    </div>
                </div>

                <div key={Resources.EnvironmentDescription}>
                    <div>
                        <div className="flex-center flex-row margin-vertical-8">
                            {Resources.EnvironmentDescription}
                            {<Icon
                                className="more-info-icon env-panel-info"
                                iconName="Info"
                                tooltipProps={{ text: Resources.ProvideEnvironmentDescription }}
                                tabIndex={0}
                                ariaLabel={Resources.ProvideEnvironmentDescription}/>
                            }
                        </div>
                        <FormItem className="form-label-margin body-m">
                            <TextField
                                multiline={true}
                                rows={5}
                                maxLength={MultiLineTextMaxLength}
                                value={this.props.environmentDescription || ""}
                                onChange={this.props.onEnvironmentDescriptionChange}
                                placeholder={Resources.ProvideEnvironmentDescription}
                            />
                        </FormItem>
                    </div>
                </div>
            </div>
        );
    }

    public componentDidMount(): void {
        focusAsync(this._environmentNameField.current as IFocusable<TextField>)
    }

    private _environmentNameField: React.RefObject<TextField> = React.createRef();
    
}
